"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuidesChartWidget = void 0;
var React = __importStar(require("react"));
var reactModalHelper_1 = require("../helpers/reactModalHelper");
var municipalityComparison_1 = require("../comparison/municipalityComparison");
var guideBoxesComponent_1 = require("./guideBoxesComponent");
// noinspection JSUnusedGlobalSymbols
exports.GuidesChartWidget = function (props) {
    reactModalHelper_1.setReactModalAppElement();
    var selectedMunicipalities = municipalityComparison_1.useMunicipalityComparison(props.initialMunicipalities).selectedMunicipalities;
    // const exampleGuideSlug = _.keys(Guides)[0] as GuideSlug;
    return React.createElement(React.Fragment, null,
        React.createElement(guideBoxesComponent_1.GuideBoxesComponent, { selectedMunicipalities: selectedMunicipalities, focusMunicipality: props.focusMunicipality, guideSlugToLink: props.guideSlugToLink, guideSlugToChecklistLink: props.guideSlugToChecklistLink }));
};
